import { connect } from 'react-redux'
import { AuthRedirect } from 'components'
import { actions } from 'appRedux/modules/Favorite'
import { actions as actionsModal } from 'appRedux/modules/Modal'
import { actions as actionsStock } from 'appRedux/modules/Stock'
import { StockFavorite as MyFav } from './StockFavorite'


const mapStateToProps = (state, ownProps) => ({ ...state.Favorite });
const mapDispatchToProps = (dispatch, ownProps) => ({
	onFavGroupDataLoad: () => dispatch(actions.loadFavGroupDataRequest()),
	onFavGroupNameEdit: (data) => dispatch(actions.editFavGroupNameRequest(data)),
	onFavGroupDataTempSort: (data) => dispatch(actions.sortFavGroupStocks(data)),
	onFavGroupDataSort: (data) => dispatch(actions.sortFavGroupStocksRequest(data)),
	onFavGroupSwitch: (idx) => dispatch(actions.switchFavGroup(idx)),
	onFavGroupStockDelete: (data) => dispatch(actions.deleteFavGroupStockRequest(data)),
	onFavGroupAdd: () => dispatch(actions.addFavGroupRequest()),

	onModalToggle: (id, open) => dispatch(actionsModal.toggleModal(id, open)),
	onStockSet: (stock) => dispatch(actionsStock.setStock(stock)),
});
const StockFavorite = AuthRedirect.AuthProps(connect(mapStateToProps, mapDispatchToProps)(MyFav))


export { StockFavorite } 
